<template>
    <div
        v-qa="'faceted-content'"
        class="faceted-content"
    >
        <CmsBlocks
            v-if="content.longDescriptionBlocks?.length"
            :data="content.longDescriptionBlocks"
        />

        <div v-else>
            <ThTitle
                v-if="content.title"
                class="title"
                tag="H2"
            >
                {{ content.title }}
            </ThTitle>

            <ContentText
                v-if="content.description"
                :data="{
                    __typename: 'ComponentText',
                    alignment: 'LEFT',
                    textSize: 'MEDIUM',
                    text: content.description,
                }"
            />

            <ContentText
                v-if="content.longDescriptionText"
                :data="{
                    __typename: 'ComponentText',
                    alignment: 'LEFT',
                    textSize: 'MEDIUM',
                    text: content.longDescriptionText,
                }"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { FacetedContentContentInterface } from '@/domain/product/useFacetedContent.ts'

import CmsBlocks from '@/components/cms/CmsBlocks.vue'
import ThTitle from '@/components/ui/title/ThTitle.vue'
import ContentText from '@/components/cms/component/content/ContentText.vue'

defineProps<{
    content: FacetedContentContentInterface
}>()
</script>

<style lang="scss" scoped>
.faceted-content {
    margin: 0 0 80px;
    padding: 0 20px;

    @include min-width(768) {
        padding: 0;
    }

    .content-title,
    .title {
        &::first-letter {
            text-transform: uppercase;
        }
    }
}
</style>
